import _ from 'lodash';
import {
  DEFAULT_FILTER_OPTION_DEPLOYMENTSET_ACTUAL,
  DEFAULT_FILTER_OPTION_DEPLOYMENTSET_DESIRED,
  DEFAULT_FILTER_OPTION_LOCNAME,
  DEFAULT_FILTER_OPTION_ORGNAME,
  DEFAULT_FILTER_OPTION_OS,
  DEFAULT_FILTER_OPTION_TAG,
  DEFAULT_FILTER_OPTION_ACTIVE,
  DEFAULT_FILTER_OPTION_SERVICE_PRINTAPI,
  DEFAULT_FILTER_OPTION_SERVICE_PAYAPI,
  DEFAULT_FILTER_OPTION_SERVICE_CAPUI,
  DEFAULT_FILTER_OPTION_SERVICE_KIOSKPROBE,
  DEFAULT_FILTER_OPTION_SERVICE_KSKAPI,
  DEFAULT_FILTER_OPTION_SERVICE_CAFEAPI,
  DEFAULT_FILTER_OPTION_SERVICE_HEATWAVE,
  DEFAULT_FILTER_OPTION_SERVICE_CORTEX,
  DEFAULT_FILTER_OPTION_STATUS,
} from '../Constants';
import Storage from '../Storage';
import User from '../model/User';

// used in App.js
export default function mapStateToProps(state) {
  let props = { ...state }; // pass all redux state/store data as props

  selectedHostInfoList(props);

  // for kiosk table select filters
  kskTagList(props);
  kskOrgNameList(props);
  kskOsNameList(props);
  kskLocNameList(props);
  kskActiveList(props);
  kskStatusList(props);
  servicePrintapiRunningList(props);
  servicePayapiRunningList(props);
  serviceCapuiRunningList(props);
  serviceKioskprobeRunningList(props);
  serviceKskapiRunningList(props);
  serviceCafeapiRunningList(props);
  serviceHeatwaveRunningList(props);
  serviceCortexAgentRunningList(props);

  // desired deployment set - the deployment set we want to use for kiosk update
  kskDeploymentSetList(props); // desired deployment set list

  // actual deployment set - calculated deployment set based on actual version of kiosk software
  kvsNamesList(props); // actual  deployment set list

  authUser(props);

  return props;
}

function selectedHostInfoList(props) {
  props.selectedHostInfoList = [];
  if (props.hostInfoList.length > 0 && props.selectedHostInfoIdList.length > 0) {
    props.selectedHostInfoList = props.hostInfoList.filter((hostInfo) =>
      _.includes(props.selectedHostInfoIdList, hostInfo.id)
    );
    props.selectedHostInfoList.forEach((h) => {
      h.calculateKvsNames(props.kvsList);
    });
    // __DEBUG__ && console.log('mapStateToProps selectedHostInfoList:', props.selectedHostInfoList);
  }
}

function kskTagList(props) {
  props.kskTagList = [];
  props.kskTagSelectOptions = [
    {
      key: DEFAULT_FILTER_OPTION_TAG,
      value: DEFAULT_FILTER_OPTION_TAG,
      label: DEFAULT_FILTER_OPTION_TAG,
    },
  ];
  if (props.hostInfoList.length > 0) {
    props.kskTagList = props.hostInfoList.map((hostInfo) => hostInfo.sosdbTag);
    props.kskTagList = _.uniq(props.kskTagList).sort();
    props.kskTagSelectOptions = [
      ...props.kskTagSelectOptions,
      ...props.kskTagList.map((sosdbTag) => {
        if (_.isEmpty(sosdbTag)) {
          sosdbTag = '';
        }
        const key = sosdbTag || '_empty';
        const value = sosdbTag;
        let label;
        switch (sosdbTag) {
          case '':
            label = 'No Tag';
            break;
          case 'prod-test':
            label = 'Prod Test (Demo/Support)';
            break;
          case 'early-update':
            label = 'Early Update';
            break;
          case 'temp-beta':
            label = 'Temp Beta';
            break;
          case 'check-before-update':
            label = 'Check Before Update';
            break;
          case 'do-not-update':
            label = 'Do Not Update';
            break;
        }
        return { key, value, label };
      }),
    ];
    // __DEBUG__ && console.log('mapStateToProps kskTagList:', props.kskTagList, props.kskTagSelectOptions);
  }
}

function kskOrgNameList(props) {
  props.kskOrgNameList = [];
  props.kskOrgNameSelectOptions = [
    {
      key: DEFAULT_FILTER_OPTION_ORGNAME,
      value: DEFAULT_FILTER_OPTION_ORGNAME,
      label: DEFAULT_FILTER_OPTION_ORGNAME,
    },
  ];
  if (props.hostInfoList.length > 0) {
    props.kskOrgNameList = props.hostInfoList.map((hostInfo) => hostInfo.orgName);
    props.kskOrgNameList = _.uniq(props.kskOrgNameList).sort();
    props.kskOrgNameSelectOptions = [
      ...props.kskOrgNameSelectOptions,
      ...props.kskOrgNameList.map((name) => {
        if (_.isEmpty(name)) {
          name = '';
        }
        return { key: name || '_empty_', value: name, label: name };
      }),
    ];
    // __DEBUG__ && console.log('App.mapStateToProps kskOrgNameList:', props.kskOrgNameList);
  }
}

function kskOsNameList(props) {
  props.kskOsNameList = [];
  props.kskOsNameSelectOptions = [
    {
      key: DEFAULT_FILTER_OPTION_OS,
      value: DEFAULT_FILTER_OPTION_OS,
      label: DEFAULT_FILTER_OPTION_OS,
    },
  ];
  if (props.hostInfoList.length > 0) {
    props.kskOsNameList = props.hostInfoList.map((hostInfo) => hostInfo.os);
    props.kskOsNameList = _.uniq(props.kskOsNameList).sort();
    props.kskOsNameSelectOptions = [
      ...props.kskOsNameSelectOptions,
      ...props.kskOsNameList.map((name) => {
        if (_.isEmpty(name)) {
          name = '';
        }
        return { key: name || '_empty_', value: name, label: name };
      }),
    ];
    // __DEBUG__ && console.log('App.mapStateToProps kskOsNameList:', props.kskOsNameList);
  }
}

function kskLocNameList(props) {
  props.kskLocNameList = [];
  props.kskLocNameSelectOptions = [
    {
      key: DEFAULT_FILTER_OPTION_LOCNAME,
      value: DEFAULT_FILTER_OPTION_LOCNAME,
      label: DEFAULT_FILTER_OPTION_LOCNAME,
    },
  ];
  if (props.hostInfoList.length > 0) {
    props.kskLocNameList = props.hostInfoList.map((hostInfo) => hostInfo.locationName);
    props.kskLocNameList = _.uniq(props.kskLocNameList).sort();
    props.kskLocNameSelectOptions = [
      ...props.kskLocNameSelectOptions,
      ...props.kskLocNameList.map((name) => {
        if (_.isEmpty(name)) {
          name = '';
        }
        return { key: name || '_empty_', value: name, label: name };
      }),
    ];
    // __DEBUG__ && console.log('App.mapStateToProps kskLocNameList:', props.kskLocNameList);
  }
}

function kskDeploymentSetList(props) {
  props.kskDeploymentSetList = [];
  props.kskDeploymentSetSelectOptions = [
    {
      key: DEFAULT_FILTER_OPTION_DEPLOYMENTSET_DESIRED,
      value: DEFAULT_FILTER_OPTION_DEPLOYMENTSET_DESIRED,
      label: DEFAULT_FILTER_OPTION_DEPLOYMENTSET_DESIRED,
    },
  ];
  if (props.hostInfoList.length > 0) {
    props.kskDeploymentSetList = props.hostInfoList.map((hostInfo) => hostInfo.sosdbDeploymentSet);
    props.kskDeploymentSetList = _.uniq(props.kskDeploymentSetList).sort();
    props.kskDeploymentSetSelectOptions = [
      ...props.kskDeploymentSetSelectOptions,
      ...props.kskDeploymentSetList.map((name) => {
        if (_.isEmpty(name)) {
          name = '';
        }
        return { key: name || '_empty_', value: name, label: name };
      }),
    ];
    // __DEBUG__ && console.log('App.mapStateToProps kskDeploymentSetList:', props.kskDeploymentSetList);
  }
}

function kskActiveList(props) {
  props.kskActiveList = [];
  props.kskActiveSelectOptions = [
    {
      key: DEFAULT_FILTER_OPTION_ACTIVE,
      value: DEFAULT_FILTER_OPTION_ACTIVE,
      label: DEFAULT_FILTER_OPTION_ACTIVE,
    },
  ];

  if (props.hostInfoList.length > 0) {
    props.kskActiveList = props.hostInfoList.map((hostInfo) => hostInfo.isActive);
    props.kskActiveList = _.uniq(props.kskActiveList).sort();
    props.kskActiveSelectOptions = [
      ...props.kskActiveSelectOptions,
      ...props.kskActiveList.map((isActive) => {
        const key = String(isActive);
        const value = String(isActive);
        let label;
        switch (key) {
          case 'true':
            label = 'Active';
            break;
          case 'false':
            label = 'Inactive';
            break;
        }
        return { key, value, label };
      }),
    ];
    // __DEBUG__ && console.log('App.mapStateToProps kskActiveList:', props.kskActiveList);
  }
}

function kvsNamesList(props) {
  props.kvsNamesList = [];
  props.kvsNamesSelectOptions = [
    {
      key: DEFAULT_FILTER_OPTION_DEPLOYMENTSET_ACTUAL,
      value: DEFAULT_FILTER_OPTION_DEPLOYMENTSET_ACTUAL,
      label: DEFAULT_FILTER_OPTION_DEPLOYMENTSET_ACTUAL,
    },
  ];
  if (props.hostInfoList.length > 0) {
    props.kvsNamesList = props.hostInfoList.map((hostInfo) => hostInfo.kvsNames);
    props.kvsNamesList = _.uniq(props.kvsNamesList).sort();
    props.kvsNamesSelectOptions = [
      ...props.kvsNamesSelectOptions,
      ...props.kvsNamesList.map((name) => {
        if (_.isEmpty(name)) {
          name = '';
        }
        return { key: name || '_empty_', value: name, label: name };
      }),
    ];
    // __DEBUG__ && console.log('App.mapStateToProps kvsNamesList:', props.kvsNamesList);
  }
}

function servicePrintapiRunningList(props) {
  props.servicePrintapiRunningList = [];
  props.servicePrintapiSelectOptions = [
    {
      key: DEFAULT_FILTER_OPTION_SERVICE_PRINTAPI,
      value: DEFAULT_FILTER_OPTION_SERVICE_PRINTAPI,
      label: DEFAULT_FILTER_OPTION_SERVICE_PRINTAPI,
    },
  ];

  if (props.hostInfoList.length > 0) {
    props.servicePrintapiRunningList = props.hostInfoList.map((hostInfo) =>
      hostInfo.printapiRunning ? true : false
    );
    props.servicePrintapiRunningList = _.uniq(props.servicePrintapiRunningList).sort();
    props.servicePrintapiSelectOptions = [
      ...props.servicePrintapiSelectOptions,
      ...props.servicePrintapiRunningList.map((printapiRunning) => {
        const key = String(printapiRunning);
        const value = String(printapiRunning);
        const label = printapiRunning ? 'Running' : 'Not Running';
        return { key, value, label };
      }),
    ];
  }
}

function servicePayapiRunningList(props) {
  props.servicePayapiRunningList = [];
  props.servicePayapiSelectOptions = [
    {
      key: DEFAULT_FILTER_OPTION_SERVICE_PAYAPI,
      value: DEFAULT_FILTER_OPTION_SERVICE_PAYAPI,
      label: DEFAULT_FILTER_OPTION_SERVICE_PAYAPI,
    },
  ];

  if (props.hostInfoList.length > 0) {
    props.servicePayapiRunningList = props.hostInfoList.map((hostInfo) =>
      hostInfo.payapiRunning ? true : false
    );
    props.servicePayapiRunningList = _.uniq(props.servicePayapiRunningList).sort();
    props.servicePayapiSelectOptions = [
      ...props.servicePayapiSelectOptions,
      ...props.servicePayapiRunningList.map((payapiRunning) => {
        const key = String(payapiRunning);
        const value = String(payapiRunning);
        const label = payapiRunning ? 'Running' : 'Not Running';
        return { key, value, label };
      }),
    ];
  }
}

function serviceCapuiRunningList(props) {
  props.serviceCapuiRunningList = [];
  props.serviceCapuiSelectOptions = [
    {
      key: DEFAULT_FILTER_OPTION_SERVICE_CAPUI,
      value: DEFAULT_FILTER_OPTION_SERVICE_CAPUI,
      label: DEFAULT_FILTER_OPTION_SERVICE_CAPUI,
    },
  ];

  if (props.hostInfoList.length > 0) {
    props.serviceCapuiRunningList = props.hostInfoList.map((hostInfo) =>
      hostInfo.capuiRunning ? true : false
    );
    props.serviceCapuiRunningList = _.uniq(props.serviceCapuiRunningList).sort();
    props.serviceCapuiSelectOptions = [
      ...props.serviceCapuiSelectOptions,
      ...props.serviceCapuiRunningList.map((capuiRunning) => {
        const key = String(capuiRunning);
        const value = String(capuiRunning);
        const label = capuiRunning ? 'Running' : 'Not Running';
        return { key, value, label };
      }),
    ];
  }
}

function serviceKioskprobeRunningList(props) {
  props.serviceKioskprobeRunningList = [];
  props.serviceKioskprobeSelectOptions = [
    {
      key: DEFAULT_FILTER_OPTION_SERVICE_KIOSKPROBE,
      value: DEFAULT_FILTER_OPTION_SERVICE_KIOSKPROBE,
      label: DEFAULT_FILTER_OPTION_SERVICE_KIOSKPROBE,
    },
  ];

  if (props.hostInfoList.length > 0) {
    props.serviceKioskprobeRunningList = props.hostInfoList.map((hostInfo) =>
      hostInfo.kioskprobeRunning ? true : false
    );
    props.serviceKioskprobeRunningList = _.uniq(props.serviceKioskprobeRunningList).sort();
    props.serviceKioskprobeSelectOptions = [
      ...props.serviceKioskprobeSelectOptions,
      ...props.serviceKioskprobeRunningList.map((kioskprobeRunning) => {
        const key = String(kioskprobeRunning);
        const value = String(kioskprobeRunning);
        const label = kioskprobeRunning ? 'Running' : 'Not Running';
        return { key, value, label };
      }),
    ];
  }
}

function serviceKskapiRunningList(props) {
  props.serviceKskapiRunningList = [];
  props.serviceKskapiSelectOptions = [
    {
      key: DEFAULT_FILTER_OPTION_SERVICE_KSKAPI,
      value: DEFAULT_FILTER_OPTION_SERVICE_KSKAPI,
      label: DEFAULT_FILTER_OPTION_SERVICE_KSKAPI,
    },
  ];

  if (props.hostInfoList.length > 0) {
    props.serviceKskapiRunningList = props.hostInfoList.map((hostInfo) =>
      hostInfo.kskapiRunning ? true : false
    );
    props.serviceKskapiRunningList = _.uniq(props.serviceKskapiRunningList).sort();
    props.serviceKskapiSelectOptions = [
      ...props.serviceKskapiSelectOptions,
      ...props.serviceKskapiRunningList.map((kskapiRunning) => {
        const key = String(kskapiRunning);
        const value = String(kskapiRunning);
        const label = kskapiRunning ? 'Running' : 'Not Running';
        return { key, value, label };
      }),
    ];
  }
}

function serviceCafeapiRunningList(props) {
  props.serviceCafeapiRunningList = [];
  props.serviceCafeapiSelectOptions = [
    {
      key: DEFAULT_FILTER_OPTION_SERVICE_CAFEAPI,
      value: DEFAULT_FILTER_OPTION_SERVICE_CAFEAPI,
      label: DEFAULT_FILTER_OPTION_SERVICE_CAFEAPI,
    },
  ];

  if (props.hostInfoList.length > 0) {
    props.serviceCafeapiRunningList = props.hostInfoList.map((hostInfo) =>
      hostInfo.cafeapiRunning ? true : false
    );
    props.serviceCafeapiRunningList = _.uniq(props.serviceCafeapiRunningList).sort();
    props.serviceCafeapiSelectOptions = [
      ...props.serviceCafeapiSelectOptions,
      ...props.serviceCafeapiRunningList.map((cafeapiRunning) => {
        const key = String(cafeapiRunning);
        const value = String(cafeapiRunning);
        const label = cafeapiRunning ? 'Running' : 'Not Running';
        return { key, value, label };
      }),
    ];
  }
}

function serviceHeatwaveRunningList(props) {
  props.serviceHeatwaveRunningList = [];
  props.serviceHeatwaveSelectOptions = [
    {
      key: DEFAULT_FILTER_OPTION_SERVICE_HEATWAVE,
      value: DEFAULT_FILTER_OPTION_SERVICE_HEATWAVE,
      label: DEFAULT_FILTER_OPTION_SERVICE_HEATWAVE,
    },
  ];

  if (props.hostInfoList.length > 0) {
    props.serviceHeatwaveRunningList = props.hostInfoList.map((hostInfo) =>
      hostInfo.heatwaveRunning ? true : false
    );
    props.serviceHeatwaveRunningList = _.uniq(props.serviceHeatwaveRunningList).sort();
    props.serviceHeatwaveSelectOptions = [
      ...props.serviceHeatwaveSelectOptions,
      ...props.serviceHeatwaveRunningList.map((heatwaveRunning) => {
        const key = String(heatwaveRunning);
        const value = String(heatwaveRunning);
        const label = heatwaveRunning ? 'Running' : 'Not Running';
        return { key, value, label };
      }),
    ];
  }
}

function serviceCortexAgentRunningList(props) {
  props.serviceCortexAgentRunningList = [];
  props.serviceCortexAgentSelectOptions = [
    {
      key: DEFAULT_FILTER_OPTION_SERVICE_CORTEX,
      value: DEFAULT_FILTER_OPTION_SERVICE_CORTEX,
      label: DEFAULT_FILTER_OPTION_SERVICE_CORTEX,
    },
  ];

  if (props.hostInfoList.length > 0) {
    props.serviceCortexAgentRunningList = props.hostInfoList.map((hostInfo) =>
      hostInfo.cortexAgentRunning ? true : false
    );
    props.serviceCortexAgentRunningList = _.uniq(props.serviceCortexAgentRunningList).sort();
    props.serviceCortexAgentSelectOptions = [
      ...props.serviceCortexAgentSelectOptions,
      ...props.serviceCortexAgentRunningList.map((cortexAgentRunning) => {
        const key = String(cortexAgentRunning);
        const value = String(cortexAgentRunning);
        const label = cortexAgentRunning ? 'Running' : 'Not Running';
        return { key, value, label };
      }),
    ];
  }
}

function kskStatusList(props){
  props.kskStatusList = [];
  props.kskStatusSelectOptions = [
    {
      key: DEFAULT_FILTER_OPTION_STATUS,
      value: DEFAULT_FILTER_OPTION_STATUS,
      label: DEFAULT_FILTER_OPTION_STATUS,
    },
  ];

  if (props.hostInfoList.length > 0 ) {
    props.kskStatusList = props.hostInfoList.map((hostInfo) => hostInfo.sosdbKioskStatus);
    props.kskStatusList = _.uniq(props.kskStatusList).sort();
    props.kskStatusSelectOptions = [
      ...props.kskStatusSelectOptions,
      ...props.kskStatusList.map((name) => {
        if (_.isEmpty(name)) {
          name = '';
        }
        return {key: name || '_empty_', value: name, label: name};
      }),
    ];
  }
}
function authUser(props) {
  let {auth: {user}} = props;
  user = user || new User();
  props.authUser = user;
  props.userEmail = user.email;
  props.isSuperUser = user.isSuperRole();
  props.isCommissionUser = user.isCommissionRole();
  props.isFrontLevelSupportUser = user.isFrontLevelSupportRole();
  props.isBasicSupportUser = user.isBasicSupportRole();
  props.isImplementationUser = user.isImplementationRole();
}



// WEBPACK FOOTER //
// ./src/redux/mapStateToProps.js